// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__23wzZ","title":"BackImages_title__2OWeC","images":"BackImages_images__1EE3T"};